import { AuthenticationService } from 'app/core/authentication';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'kh-saml-internal-logout',
    template: '',
    standalone: false
})
export class SamlInternalLogoutComponent implements OnInit {

  public constructor(
    private readonly authenticationService: AuthenticationService
  ) { }

  public ngOnInit(): void {
    this.authenticationService.logOut(false);
  }
}
